import React from 'react'
import i18next from 'i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { TransactionType } from 'types/transaction/TransactionType'

interface CommonFieldsProps {
  transactionHash: string
  transactionDate: string
  transactionUUID: string
}

const CommonFields = ({ transactionHash, transactionDate, transactionUUID }: CommonFieldsProps) => {
  return (
    <>
      {transactionUUID && (
        <DataListItem
          id="transaction-uuid"
          testId="transaction-uuid"
          title={i18next.t('transactions.sideBar.uuid')}
          body={ellipseMiddleText(transactionUUID, 20, 10)}
          copyText={transactionUUID}
        />
      )}

      {transactionHash && (
        <Box>
          <DataListItem
            id="transaction-hash"
            testId="transaction-hash"
            title={i18next.t('hash')}
            body={ellipseMiddleText(transactionHash, 20, 10)}
            copyText={transactionHash}
            {...(transactionHash.includes(TransactionType.OFF_CHAIN) && {
              externalLink: process.env.OFF_CHAIN_INFO_LINK,
            })}
          />
        </Box>
      )}
      {transactionDate && (
        <DataListItem
          id="transaction-date"
          testId="transaction-date"
          title={i18next.t('date')}
          body={transactionDate}
        />
      )}
    </>
  )
}

export default CommonFields
